import { DocumentParams } from '~/core/shared/api/documents/types/DocumentParams';
import { Module } from '~/core/shared/constants';
import { TenantedApplicationConfig } from '~/core/shared/contexts';

export const buildDefinitionParams = (
  definition: string | undefined,
  config: TenantedApplicationConfig,
): DocumentParams | undefined => {
  if (!definition) return undefined;
  const primaryWorkflow =
    config.documents[definition]?.modules[Module.MiddleOffice]?.primaryWorkflow;
  if (!primaryWorkflow) return undefined;

  const { workflowDefinition, statusDefinition } = primaryWorkflow;
  return { definition, statusDefinition, workflow: workflowDefinition };
};
